<template>
  <div class="ctx">
    <div class="ctx-item">
      <span class="label">University</span>
      <span class="value">{{ universityName || '—' }}</span>
    </div>
    <div class="ctx-item">
      <span class="label">Ceremony</span>
      <span class="value" :class="{ muted: !ceremonyText }">{{ ceremonyText || 'No ceremony selected' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContextHeader',
  props: {
    universityName: { type: String, default: '' },
    ceremonyText: { type: String, default: '' }
  }
}
</script>

<style scoped>
.ctx { display: flex; gap: 16px; padding: 10px 12px; background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 8px; margin-bottom: 12px; }
.ctx-item { display: flex; gap: 6px; align-items: baseline; }
.label { color: #6b7280; font-size: 12px; text-transform: uppercase; letter-spacing: 0.02em; }
.value { font-weight: 600; }
.muted { color: #9ca3af; font-weight: 500; }
</style>

